import axios from "axios";
import { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SwiperCore, { Pagination, Navigation, Autoplay, EffectFade } from "swiper";
import { Swiper } from 'swiper/react';
import { useParams, useRouteMatch } from "react-router"
import PageHeading from "../../../components/__simple/_pageheading"
import { WhyHJSection } from "../../../sections/whyHJSection";
import { MaintenanceServiceBox } from "../components/maintenance";
import ServiceDescription from "../components/serviceDescription";
import ServicesList from "../components/servicesList";
import MaintenanceContext from "../maintenanceContext";
import ServiceHeaderBanner from "../components/serviceHeaderBanner";
import Breadcrumb from "../../../components/__simple/breadcrumb";
import config from "../../../configuration/config";
SwiperCore.use([Pagination, Navigation, Autoplay, EffectFade]);
const SubServicePage = () => {
    const [maintenanceInfo, setMaintenanceInfo] = useState({});
    const { t: trans, i18n } = useTranslation(["info", "common"]);
    const { handleServiceOrder } = useContext(MaintenanceContext);
    const { path } = useRouteMatch();
    const languageDir = 'language-' + (i18n.language || 'ar');
    //----------------------------------------------
    let { ID } = useParams();
    const [SubService, setSubService] = useState([]);
    function fetchSubService(SubID) {
        const Body = {
            "SubID": SubID
        }

        axios.request({
            url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/site_fetchMntc_SubService2`,
            data: Body, method: "POST", responseType: "json"
        })
            .then(function (response) {
                // console.log(response.data.ApiObjectData);
                setTimeout(setSubService(response.data), 1000);

            })
            .catch(function (error) {
                console.log(error);
            });



    }
    const [SubInfo, setSubInfo] = useState([]);
    function fetchSubnfo(IDMain) {
        const Body = {
            "Sub1 ": IDMain
        }

        axios.request({
            url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/site_fetchInfo_SubService1`,
            data: Body, method: "POST", responseType: "json"
        })
            .then(function (response) {
                // console.log(response.data.ApiObjectData);
                setTimeout(setSubInfo(response.data), 1000);
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    const [lang, setlang] = useState(localStorage.getItem('i18nextLng'));
    useEffect(async () => {
        try {
            fetchSubService(ID);
            fetchSubnfo(ID);
            const response = await axios.request({
                baseURL: config.controllURL,
                url: (i18n.language || 'ar') + "/api/maintenance/index",
                method: "get",
            });
            setMaintenanceInfo(response.data);
        } catch (error) {
            console.log(error);
        }
    }, []);
    return (
        <>
            {

                SubInfo.map((p) => {

                    return (<ServiceHeaderBanner
                        bannerDescriptor={{ image: p.img, subTitle: '', title: lang === "en" ? p.DescriptionEn : p.DescriptionAr }}
                        hasRedirect={false}
                    />)
                })
            }
            <div className="container">
                <Breadcrumb className={"mt-16 "}
                    links={[
                        {
                            name: trans("info:maintenance"),
                            to: '/maintenance'
                        },
                        {
                            name: trans("info:main_sub_main_service"),
                            to: `${path}`
                        },
                        {
                            name: trans("info:main_service_types"),
                            to: `${path}`
                        }
                    ]}
                />
            </div>
            <div className={"w-full mb-32 " + languageDir}>
                <div className="mainteance-services-wrapper">
                    <div className="section-heading-container">
                        <h2 className="section-heading">{trans("info:main_service_types")}</h2>
                    </div>
                    <div className="mainteance-scroll-container">
                        <div className="mainteance-horizontal-list">
                            {
                                SubService.map((item, index) => {
                                    return (
                                        <div key={index} className="flex-shrink-0">
                                            <MaintenanceServiceBox
                                                image={item.img ? `url('${(config.mainURL + item.img.replaceAll("\\", "/"))}')` : `url('/assets/images/defult.png')`}
                                                to={"#"}
                                                title={lang === 'ar' ? item.DescriptionAr : item.DescriptionEn}
                                                onServiceOrder={() => {
                                                    handleServiceOrder({
                                                        showPopup: true,
                                                        type: item.Level,
                                                        main: item.MainServiceID,
                                                        sub1: item.SubService1ID,
                                                        sub2: item.SubService2ID
                                                    });
                                                }}
                                            />
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
            <WhyHJSection />
        </>
    );
}
export default SubServicePage;